import React from 'react';
import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';

const PublishProcessAsset = () => {
  const { isSubmitEnabled, submitForm } = useFormContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        '.MuiFormControl-root': { mb: 0, '> label': { mr: 0 } },
      }}
    >
      <Button disabled={!isSubmitEnabled} onClick={submitForm} color="secondary">
        Publish
      </Button>
    </Box>
  );
};

export default PublishProcessAsset;
